import React from "react";
import { withStyles } from "@material-ui/core";
import { get, map } from "lodash";
import clsx from "clsx";

import Grid from "@material-ui/core/Grid";

import { hourToAmPm } from "../../../utils/date";
import { getTimeSlotHeight } from "../../../utils/scheduler";

import { calendarViews } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const styles = {
  container: {
    width: "42px",
    fontSize: "0.857em",
    textAlign: "right",
    paddingRight: "6px",
    color: colors.black87,
  },
  daily: {
    paddingTop: "32px",
  },
  weekly: {
    paddingTop: "82px",
  },
  endSlot: {
    minHeight: "26px",
  },
};

const SchedulerTimeSlotsColumn = (props) => {
  const { classes, timeSlots, occurrencesPerDay, calendarView } = props;

  return (
    <Grid
      container
      direction="column"
      className={clsx(classes.container, {
        [classes.daily]: calendarView === calendarViews.daily,
        [classes.weekly]: calendarView === calendarViews.weekly,
      })}
    >
      {map(timeSlots, (slot, index) => (
        <React.Fragment key={index}>
          <Grid
            item
            className={classes.startSlot}
            style={{
              height:
                getTimeSlotHeight(occurrencesPerDay, slot, calendarView) + 2,
            }}
          >
            {hourToAmPm(
              get(slot, ["start", "hours"]),
              get(slot, ["start", "minutes"])
            )}
          </Grid>
          <Grid item className={classes.endSlot}>
            {hourToAmPm(
              get(slot, ["end", "hours"]),
              get(slot, ["end", "minutes"])
            )}
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default withStyles(styles)(SchedulerTimeSlotsColumn);
